'use client';
import { RecentActivity, TranslationRequestStatusEnum } from 'gql/graphql';
import {
  AiSessionDashboardAiIcon,
  CommentDashboardAiIcon,
  ContentCreatorDashboardAiIcon,
  TranslationCancelledDashboardAiIcon,
  TranslationCreatedDashboardAiIcon,
  TranslationFinishedDashboardAiIcon,
  TranslationInProgressDashboardAiIcon,
  TranslationQuotedDashboardAiIcon,
  TranslationReadyToReviewDashboardAiIcon
} from 'lib/svgs/Icons';
import { FC } from 'react';
import { cn } from 'utils/cn';
import { KeysRecentActivities } from '..';

interface IActivityKey {
  activity: RecentActivity;
  status: string;
}

const ActivityKey: FC<IActivityKey> = ({ activity, status }) => {
  return (
    <>
      {(activity.key === KeysRecentActivities.TranslationRequestChanged ||
        activity.key === KeysRecentActivities.TranslationRequestCreated) && (
        <>
          {!status && (
            <TranslationCreatedDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
          )}
          {status === TranslationRequestStatusEnum.InTranslation && (
            <TranslationInProgressDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
          )}
          {status === TranslationRequestStatusEnum.Unordered && (
            <TranslationQuotedDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
          )}
          {status === TranslationRequestStatusEnum.WaitingForClient && (
            <TranslationReadyToReviewDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
          )}
          {status === TranslationRequestStatusEnum.Finished && (
            <TranslationFinishedDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
          )}
          {status === TranslationRequestStatusEnum.Canceled && (
            <TranslationCancelledDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
          )}
        </>
      )}
      {activity.key === KeysRecentActivities.CommentCreated && (
        <CommentDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
      )}
      {activity.key === KeysRecentActivities.ThreadCreated && (
        <AiSessionDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
      )}
      {activity.key === KeysRecentActivities.GeneratedContentCreate && (
        <ContentCreatorDashboardAiIcon className={cn('absolute -top-0.5 mt-1')} />
      )}
    </>
  );
};

export default ActivityKey;
